/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../instant-deposit/instant_deposits';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "ExternalCardService": {
            "methods": {
              "ConfirmCardChange": {
                "requestType": "squareup.ledger.service.VerifyCardChangeRequest",
                "responseType": "squareup.ledger.service.VerifyCardChangeResponse"
              },
              "LinkCard": {
                "requestType": "squareup.ledger.service.LinkCardRequest",
                "responseType": "squareup.ledger.service.LinkCardResponse"
              },
              "ResendVerificationMessage": {
                "requestType": "squareup.ledger.service.ResendVerificationEmailRequest",
                "responseType": "squareup.ledger.service.ResendVerificationEmailResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.ExternalCardService) {
  $root.addJSON(jsonData);
}

/**
 * This service exposes external endpoints related to linking cards for Instant Deposit for use by
 * Dashboard/Onboard.
 *
 * SOURCE ExternalCardService @ squareup/deposits/card_service.proto at 18:1
 */
export const ExternalCardService = $root.lookupService('squareup.deposits.ExternalCardService');